import { useMutation } from '@tanstack/react-query';
import { GET, GET_CLAIM_FULL_SEARCH } from '../../../../services';
import { useState } from 'react';

export const useGetClaimFull = ({ handleSubmit }) => {
  const [data, setData] = useState([]);
  const { mutate: onSearchFull, isPending } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(
        GET_CLAIM_FULL_SEARCH({
          search: search || '',
        }),
      );
      return response.result.items || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });
  const onFetchFull = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();
  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetchFull };
};
